@if (banner$ | async; as banner) {
  @if (banner.visible) {
    <div class="banner__container">
      <picture
        class="banner__container__background"
        [ngClass]="{ 'banner__container__background--empty': !banner?.image?.thumbnail }"
        [ngStyle]="{
          'background-image': banner?.image?.thumbnail ? 'url(' + banner?.image?.thumbnail + ')' : undefined,
        }">
        @if (banner?.image?.url) {
          @for (px of [500, 600, 800, 1024]; track px) {
            <source
              [srcset]="$any(banner.image)['vw' + px]"
              [media]="'(max-width:' + px + 'px)'" />
          }
          <img
            loading="eager"
            alt="background banner"
            [ngStyle]="{
              filter: !bannerImageLoaded && banner?.image?.thumbnail ? 'blur(10px)' : undefined,
            }"
            [src]="banner.image.vw1280"
            (load)="onImageLoad()" />
        }
        <div class="banner__container__description">
          <h1>{{ banner.title }}</h1>
        </div>
      </picture>
    </div>
    @if (banner?.title) {
      <div class="banner__container__text">
        <div [innerHTML]="banner.text"></div>
        @if (banner?.aiGenerated) {
          <small>{{ 'banner.ai-generated' | i18next }}</small>
        }
      </div>
    }
    @if (banner.relatedSearchBanners | sharryRelatedFindVisible) {
      <div class="banner__related">
        <h2>{{ 'banner.related-search' | i18next }}</h2>
        <div class="divider"></div>
        <mat-accordion
          displayMode="flat"
          [multi]="false">
          @for (
            related of banner.relatedSearchBanners | sharryRelatedVisible: 0 : 5;
            track related.id;
            let i = $index
          ) {
            <mat-expansion-panel
              class="sharry-flat-panel"
              (opened)="openChange(i)">
              <mat-expansion-panel-header>
                <mat-panel-title
                  ><img
                    loading="lazy"
                    style="object-fit: cover"
                    width="150"
                    alt=""
                    [height]="'64'"
                    [src]="$any(related.image).preview" />{{ related.title }}
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="banner__related__body cursor-pointer">
                <p>
                  {{ related.text }}
                </p>
                <a
                  mat-flat-button
                  color="primary"
                  class="rounded sharry-medium"
                  [routerLink]="related | sharryBannerRedirect">
                  {{ 'banner.button-discover' | i18next }}
                </a>
              </div>
            </mat-expansion-panel>
          }
        </mat-accordion>
      </div>
    }
  }
}
